import React, { ReactNode } from "react";
import Header from "./Header";
import Footer from "./Footer";

interface LayoutProps {
  children: ReactNode;
  className?: string;
}
const DefaultLayout: React.FC<LayoutProps> = ({ children, className }) => {
  return (
    <div className="flex flex-col justify-center min-h-screen ">
      <Header />
      <main className={`w-full flex-grow ${className}`}>{children}</main>
      <Footer />
    </div>
  );
};

export default DefaultLayout;
